// extracted by mini-css-extract-plugin
export default {"extrasForm":"Extras_extrasForm__Q6uSw","listOfAllOfferedExtras":"Extras_listOfAllOfferedExtras__FlEI-","selected":"Extras_selected__nI4M9"};